import React from "react";

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary]", error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={styles.wrapper}>
          <div style={styles.card}>
            <div style={styles.icon}>⚠️</div>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.message}>
              {this.state.error?.message || "An unexpected error occurred."}
            </p>
            <button style={styles.btn} onClick={this.handleReset}>
              Try Again
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const styles = {
  wrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    padding: "24px",
    background: "#f8fafc",
  },
  card: {
    background: "#ffffff",
    borderRadius: "14px",
    border: "1px solid #e2e8f0",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.06)",
    padding: "48px 40px",
    textAlign: "center",
    maxWidth: "420px",
    width: "100%",
  },
  icon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  title: {
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
    fontSize: "18px",
    fontWeight: 700,
    color: "#0f172a",
    margin: "0 0 8px",
  },
  message: {
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
    fontSize: "13px",
    color: "#64748b",
    margin: "0 0 28px",
    lineHeight: 1.6,
  },
  btn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "10px 24px",
    borderRadius: "9px",
    border: "none",
    background: "linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)",
    color: "#78350f",
    fontFamily: "'Space Grotesk', 'DM Sans', sans-serif",
    fontSize: "13px",
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 3px 12px rgba(245,158,11,0.35)",
  },
};

export default ErrorBoundary;
